<template>
    <v-dialog v-model="editorShownStandby" width="850" persistent>
        <!-- Begin:Content:Mode:update ------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 2px solid red;">
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-bullhorn"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Standby List ------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees/Standbys:</strong></div>
            <selected-standby-list v-model="employees" v-if="editorShownStandby" />

            <v-divider style="margin-top: 20px;"></v-divider>

           <!-- Selecting Standby ------------------------------------------ -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa-user-friend"></i><strong>Build your Standby:</strong></div>
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Standby - from:" disabled="false" disabledTime="false" ref="startTimer" />
                <datetime v-model="endDate" label="Standby - to:" disabled="false" disabledTime="false" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <airports-combo v-model="aptCode" label="Select Arprt:" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Standy Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiEvents('STANDBY').length }} Standby(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_StandbyDialog">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_StandbyUpdate"> Save</v-btn>
            </v-card-actions>
        </v-card>



        <!-- Begin:Content:Mode:create ------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 2px solid red;">
            <!-- Card Title ------------------------------------------------ -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-bullhorn"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Employees List ----------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees:</strong></div>
            <selected-employees-list v-model="employees" v-if="editorShownStandby" />

            <v-divider style="margin-top: 0px;"></v-divider>

            <!-- Selecting Standby ----------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa  b-fa-bullhorn"></i><strong>Build your Standby:</strong></div>
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Standby - from:" disabled="false" disabledTime="false" ref="startTimer" />
                <datetime v-model="endDate" label="Standby - to:" disabled="false" disabledTime="false" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <airports-combo v-model="aptCode" label="Select Arprt:" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Standby Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiResources.length }} Employee(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_StandbyDialog">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_StandbyCreate"> Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import AirportsCombo from '../../AirportsCombo.vue';
    import CommentTextarea from '../../CommentTextarea.vue';
    import SelectedStandbyList from '../../SelectedStandbyList.vue';
    import SelectedEmployeesList from '../../SelectedEmployeesList.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-standby',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownStandby
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,
            AirportsCombo,
            CommentTextarea,
            SelectedStandbyList,
            SelectedEmployeesList,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            idApt           : null, // gets set in: 'get_AirportId'
            aptCode         : null,
            // >>> ------------------------------
            dutyComment     : null,
            employees       : [],
            // >>> ------------------------------

        }), // eo function data()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Computed */
        computed : {

            ...mapGetters([
                'get_Airports',
                'get_selectedMultiResources',
                'get_selectedMultiEvents',
                'get_shared_IsEditingInThePastAllowed'
            ]),


            /*******************************************************************
            * editorShownDayoff()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownStandby: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note:
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/standby/EventEditor.vue >>> editorShownStandby get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName, // eventRecord.name,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    idApt           : eventRecord.idApt,
                                    aptCode         : eventRecord.aptCode,
                                    dutyComment     : eventRecord.dutyComment,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    idApt           : null,
                                    aptCode         : null,
                                    dutyComment     : null,
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo editorShownStandby get

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/standby/EventEditor.vue >>> editorShownStandby set');
                    this.$emit('input', value);

                } // eo editorShownStandby set

            } // eo function editorShownStandby()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to: 'updatestandby'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditor.vue >>> created');
            eventBus.$on('updatestandby', this.onUpdate_SingleDuty); // call: modify single duty successful
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker); // onChange_DatePicker (not used right now)

        }, // eo function created()

        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditor.vue >>> beforeDestroy');
            eventBus.$off('updatestandby', this.onUpdate_SingleDuty);
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_SelectedMultiEvents',
                'actn_create_Multiple_Duty',
                'actn_update_Multiple_Duty',
                'actn_update_SingleDuty', // Call: Modify Single Duty
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_StandbyUpdate()
            *
            * Desc: 'Update Standby(s)' - Call.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_StandbyUpdate: function() {

                let me = this,
                    singleParamObject = {},
                    params = {
                        breaks : []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditor.vue >>> onSave_StandbyUpdate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.employees.forEach(employee => {
                    singleParamObject = {
                        id: employee.originalId,
                        idResource: employee.resourceId,
                        from: moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        to: moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        type: 'STANDBY',
                        status: 'PLANNED',
                        idApt: this.get_AirportId(me.aptCode),
                        activationDate  : me.eventRecord.activationDate !== null ? moment(me.eventRecord.activationDate).format('YYYY-MM-DDTHH:mm:ss+0000') : null,
                        dutyComment: me.dutyComment !== '' ? me.dutyComment : null
                    };
                    params.breaks.push(singleParamObject);
                });

                if (this.validateParams(params) === true) {
                    this.actn_update_Multiple_Duty(params);
                }

            }, // eo function onSave_StandbyUpdate()


            /*******************************************************************
            * onSave_StandbyCreate()
            *
            * Desc: 'Create Standby(s)' - Call.
            * Note:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_StandbyCreate: function() {

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditor.vue >>> onSave_StandbyCreate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : null,
                    // idResource      : this.resourceRecord.id,
                    idResources : this.employees,
                    from            : moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    type            : 'STANDBY',
                    status          : 'PLANNED',
                    idApt           : this.get_AirportId(me.aptCode),
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null
                };

                if (this.validateParams(params) === true) {
                    this.actn_create_Multiple_Duty(params);
                    this.actn_set_SelectedMultiEvents([]); // send empty Array
                }

            }, // eo function onSave_StandbyCreate()


            /*******************************************************************
            * onClose_StandbyDialog()
            *
            * Desc: Close Standby Dialog.
            * Note: Reset 'all selected Events' here.
            *
            */
            onClose_StandbyDialog: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditor.vue >>> onClose_StandbyDialog');
                this.actn_set_SelectedMultiEvents([]); // send empty Array, #244
                me.editorShownStandby = false;

                eventBus.$emit('schedulerdeselectall'); // #401

            }, // eo function onClose_StandbyDialog()




            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onUpdate_SingleDuty()
            *
            * Desc: Successful Call => emits 'updatestandby' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of Call:'actn_update_SingleDuty' for
            * Note: buildEventNote.
            * Note: 'Create' happens in CrewCalendar.
            * TODO: Still used?
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_SingleDuty: function(response) {

                let me = this,
                    style = null,
                    tooltipData = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditor.vue >>> onUpdate_SingleDuty');
                me.eventRecord.setStartEndDate(me.startDate, me.endDate);
                me.eventRecord.set({ idApt: me.idApt });
                me.eventRecord.set({ aptCode: me.aptCode });
                me.eventRecord.set({ dutyComment: response.dutyComment });

                tooltipData = me.$buildEventNote(response); // Catch after 'requested was set!: Important
                me.eventRecord.set({ nameEvent: tooltipData.nameEvent });
                me.eventRecord.set({ note: tooltipData.note });

                // >>> Style ----------------------------------------
                if (response.activationDate !== null) {
                    style = 'background: repeating-linear-gradient(45deg,#b28b84,#b28b84 10px,#d8cdcb 10px,#d8cdcb 20px); color: #fff;';
                };
                if (response.dutyComment !== null) {
                    if (style !== null) {
                        style = style + ' border-right: 3px dotted #000;';
                    } else {
                        style = ' border-right: 3px dotted #000;';
                    }
                }
                me.eventRecord.set({ style: style });
                // <<< Style ----------------------------------------

                if (!me.eventRecord.eventStore) {
                    me.eventStore.add(me.eventRecord);
                    me.eventRecord.resourceId = me.resourceId;
                }

                // >>> close the editor now ...
                me.editorShownStandby = false;

            }, // eo function onUpdate_SingleDuty()


            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            * Note:
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value) {

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditor.vue >>> onChange_DatePicker');
                // newDate = new Date(value);
                // newDate.setHours(23);
                // newDate.setMinutes(59);
                // me.endDate = newDate;

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams()
            *
            * Desc: Checks/Validates Params before send to Backend.
            * Note: Kind if cascading Validations.
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    a = null,
                    b = null,
                    diffInHours = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditor.vue >>> validateParams');
                // >>> -------------------------- 'startDate bef endDate?'      // Check 1
                startDate = moment(params.from);
                endDate = moment(params.to);
                if (endDate.isBefore(startDate)) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: EndDate must be after StartDate.'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
                // <<< --------------------------


                // >>> -------------------------- 'aptCode?'                    // Check 2
                if (valid === true) {  // still valid
                    if (me.aptCode === null || me.aptCode === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: Airport is a required field'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------


                // >>> -------------------------- 'over 16 hours?'              // Check 2
                if (valid === true) {  // still valid
                    a = moment(me.startDate);
                    b = moment(me.endDate);
                    diffInHours = b.diff(a, 'hours');
                    if (diffInHours > 16) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: Standby may be 16h at maximum. '
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------


                return valid;

            }, // eo function validateParams()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_AirportId()
            *
            * Desc: Return Airports ID.
            * Note:
            *
            */
            get_AirportId: function(code) {

                let me = this,
                    aptId = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditor.vue >>> get_AirportId');
                this.get_Airports.forEach((apt, i) => {
                    if (apt.aptCode === code) {
                        this.idApt = apt.idAirport;
                        aptId = apt.idAirport;
                    }
                });


                return aptId;

            } // eo function get_AirportId()

        } // eo methods
        /* <<< ****************************************************************/

    };
</script>
